var exports = {
  "X": "ConnectionsTab.module__confirmDescription___N2ZJQS",
};

module.exports = exports;
